import { z } from "zod";
import { optionalEmailSchema, phoneSchema } from "./common.schema.ts";

export const createParentSchema = z.object({
  nom: z
    .string()
    .trim()
    .min(2, "Le nom est requis et doit avoir au minimum 2 caractères")
    .max(100, "Maximum 100 caractères"),

  postnom: z
    .string()
    .trim()
    .min(2, "Le postnom est requis et doit avoir au minimum 2 caractères")
    .max(100, "Maximum 100 caractères"),

  prenom: z
    .string()
    .trim()
    .min(2, "Le prénom est requis et doit avoir au minimum 2 caractères")
    .max(100, "Maximum 100 caractères"),

  sexe: z
    .string()
    .trim()
    .min(1, "Le genre est requis ")
    .max(100, "Maximum 100 caractères"),

  type: z.preprocess(
    (value) => value ?? "",
    z
      .string()
      .trim()
      .min(1, "Le type de parenté est requis")
      .max(100, "Maximum 100 caractères"),
  ),

  avenue: z
    .string()
    .trim()
    .min(2, "L'avenue est requise et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),
  commune: z
    .string()
    .trim()
    .min(2, "La commune est requise et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),
  quartier: z
    .string()
    .trim()
    .min(2, "Le quartier est requis et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),
  ville: z
    .string()
    .trim()
    .min(2, "La ville est requise et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),

  email: optionalEmailSchema,

  telephone: phoneSchema,

  profession: z.preprocess(
    (value) => value ?? "",
    z
      .string()
      .trim()
      .min(2, "La profession est requise et doit avoir au minimum 2 caractères")
      .max(250, "Maximum 250 caractères"),
  ),
});
